// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file communities.proto (syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { ChatIdentity } from './chat-identity_pb'
import { file_chat_identity } from './chat-identity_pb'
import type { CommunityTokenType } from './enums_pb'
import { file_enums } from './enums_pb'
import type { Shard } from './shard_pb'
import { file_shard } from './shard_pb'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file communities.proto.
 */
export const file_communities: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [file_chat_identity, file_enums, file_shard],
  )

/**
 * @generated from message Grant
 */
export type Grant = Message<'Grant'> & {
  /**
   * @generated from field: bytes community_id = 1;
   */
  communityId: Uint8Array

  /**
   * @generated from field: bytes member_id = 2;
   */
  memberId: Uint8Array

  /**
   * @generated from field: string chat_id = 3;
   */
  chatId: string

  /**
   * @generated from field: uint64 clock = 4;
   */
  clock: bigint
}

/**
 * Describes the message Grant.
 * Use `create(GrantSchema)` to create a new message.
 */
export const GrantSchema: GenMessage<Grant> =
  /*@__PURE__*/
  messageDesc(file_communities, 0)

/**
 * @generated from message CommunityMember
 */
export type CommunityMember = Message<'CommunityMember'> & {
  /**
   * @generated from field: repeated CommunityMember.Roles roles = 1;
   */
  roles: CommunityMember_Roles[]

  /**
   * @generated from field: repeated RevealedAccount revealed_accounts = 2 [deprecated = true];
   * @deprecated
   */
  revealedAccounts: RevealedAccount[]

  /**
   * @generated from field: uint64 last_update_clock = 3;
   */
  lastUpdateClock: bigint

  /**
   * @generated from field: CommunityMember.ChannelRole channel_role = 4;
   */
  channelRole: CommunityMember_ChannelRole
}

/**
 * Describes the message CommunityMember.
 * Use `create(CommunityMemberSchema)` to create a new message.
 */
export const CommunityMemberSchema: GenMessage<CommunityMember> =
  /*@__PURE__*/
  messageDesc(file_communities, 1)

/**
 * @generated from enum CommunityMember.Roles
 */
export enum CommunityMember_Roles {
  /**
   * @generated from enum value: ROLE_NONE = 0;
   */
  ROLE_NONE = 0,

  /**
   * @generated from enum value: ROLE_OWNER = 1;
   */
  ROLE_OWNER = 1,

  /**
   * @generated from enum value: ROLE_ADMIN = 4;
   */
  ROLE_ADMIN = 4,

  /**
   * @generated from enum value: ROLE_TOKEN_MASTER = 5;
   */
  ROLE_TOKEN_MASTER = 5,
}

/**
 * Describes the enum CommunityMember.Roles.
 */
export const CommunityMember_RolesSchema: GenEnum<CommunityMember_Roles> =
  /*@__PURE__*/
  enumDesc(file_communities, 1, 0)

/**
 * @generated from enum CommunityMember.ChannelRole
 */
export enum CommunityMember_ChannelRole {
  /**
   * We make POSTER the first role to be the default one.
   * This is for backwards compatibility. Older protobufs won't have this field and will default to 0.
   *
   * @generated from enum value: CHANNEL_ROLE_POSTER = 0;
   */
  POSTER = 0,

  /**
   * @generated from enum value: CHANNEL_ROLE_VIEWER = 1;
   */
  VIEWER = 1,
}

/**
 * Describes the enum CommunityMember.ChannelRole.
 */
export const CommunityMember_ChannelRoleSchema: GenEnum<CommunityMember_ChannelRole> =
  /*@__PURE__*/
  enumDesc(file_communities, 1, 1)

/**
 * @generated from message CommunityTokenMetadata
 */
export type CommunityTokenMetadata = Message<'CommunityTokenMetadata'> & {
  /**
   * @generated from field: map<uint64, string> contract_addresses = 1;
   */
  contractAddresses: { [key: string]: string }

  /**
   * @generated from field: string description = 2;
   */
  description: string

  /**
   * @generated from field: string image = 3;
   */
  image: string

  /**
   * @generated from field: CommunityTokenType tokenType = 4;
   */
  tokenType: CommunityTokenType

  /**
   * @generated from field: string symbol = 5;
   */
  symbol: string

  /**
   * @generated from field: string name = 6;
   */
  name: string

  /**
   * @generated from field: uint32 decimals = 7;
   */
  decimals: number
}

/**
 * Describes the message CommunityTokenMetadata.
 * Use `create(CommunityTokenMetadataSchema)` to create a new message.
 */
export const CommunityTokenMetadataSchema: GenMessage<CommunityTokenMetadata> =
  /*@__PURE__*/
  messageDesc(file_communities, 2)

/**
 * @generated from message CommunityPermissions
 */
export type CommunityPermissions = Message<'CommunityPermissions'> & {
  /**
   * @generated from field: bool ens_only = 1;
   */
  ensOnly: boolean

  /**
   * https://gitlab.matrix.org/matrix-org/olm/blob/master/docs/megolm.md is a candidate for the algorithm to be used in case we want to have private communityal chats, lighter than pairwise encryption using the DR, less secure, but more efficient for large number of participants
   *
   * @generated from field: bool private = 2;
   */
  private: boolean

  /**
   * @generated from field: CommunityPermissions.Access access = 3;
   */
  access: CommunityPermissions_Access
}

/**
 * Describes the message CommunityPermissions.
 * Use `create(CommunityPermissionsSchema)` to create a new message.
 */
export const CommunityPermissionsSchema: GenMessage<CommunityPermissions> =
  /*@__PURE__*/
  messageDesc(file_communities, 3)

/**
 * @generated from enum CommunityPermissions.Access
 */
export enum CommunityPermissions_Access {
  /**
   * @generated from enum value: UNKNOWN_ACCESS = 0;
   */
  UNKNOWN_ACCESS = 0,

  /**
   * @generated from enum value: AUTO_ACCEPT = 1;
   */
  AUTO_ACCEPT = 1,

  /**
   * @generated from enum value: INVITATION_ONLY = 2 [deprecated = true];
   * @deprecated
   */
  INVITATION_ONLY = 2,

  /**
   * @generated from enum value: MANUAL_ACCEPT = 3;
   */
  MANUAL_ACCEPT = 3,
}

/**
 * Describes the enum CommunityPermissions.Access.
 */
export const CommunityPermissions_AccessSchema: GenEnum<CommunityPermissions_Access> =
  /*@__PURE__*/
  enumDesc(file_communities, 3, 0)

/**
 * @generated from message TokenCriteria
 */
export type TokenCriteria = Message<'TokenCriteria'> & {
  /**
   * @generated from field: map<uint64, string> contract_addresses = 1;
   */
  contractAddresses: { [key: string]: string }

  /**
   * @generated from field: CommunityTokenType type = 2;
   */
  type: CommunityTokenType

  /**
   * @generated from field: string symbol = 3;
   */
  symbol: string

  /**
   * @generated from field: string name = 4;
   */
  name: string

  /**
   * @generated from field: string amount = 5 [deprecated = true];
   * @deprecated
   */
  amount: string

  /**
   * @generated from field: repeated uint64 token_ids = 6;
   */
  tokenIds: bigint[]

  /**
   * @generated from field: string ens_pattern = 7;
   */
  ensPattern: string

  /**
   * @generated from field: uint64 decimals = 8;
   */
  decimals: bigint

  /**
   * @generated from field: string amountInWei = 9;
   */
  amountInWei: string
}

/**
 * Describes the message TokenCriteria.
 * Use `create(TokenCriteriaSchema)` to create a new message.
 */
export const TokenCriteriaSchema: GenMessage<TokenCriteria> =
  /*@__PURE__*/
  messageDesc(file_communities, 4)

/**
 * @generated from message CommunityTokenPermission
 */
export type CommunityTokenPermission = Message<'CommunityTokenPermission'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: CommunityTokenPermission.Type type = 2;
   */
  type: CommunityTokenPermission_Type

  /**
   * @generated from field: repeated TokenCriteria token_criteria = 3;
   */
  tokenCriteria: TokenCriteria[]

  /**
   * @generated from field: repeated string chat_ids = 4;
   */
  chatIds: string[]

  /**
   * @generated from field: bool is_private = 5;
   */
  isPrivate: boolean
}

/**
 * Describes the message CommunityTokenPermission.
 * Use `create(CommunityTokenPermissionSchema)` to create a new message.
 */
export const CommunityTokenPermissionSchema: GenMessage<CommunityTokenPermission> =
  /*@__PURE__*/
  messageDesc(file_communities, 5)

/**
 * @generated from enum CommunityTokenPermission.Type
 */
export enum CommunityTokenPermission_Type {
  /**
   * @generated from enum value: UNKNOWN_TOKEN_PERMISSION = 0;
   */
  UNKNOWN_TOKEN_PERMISSION = 0,

  /**
   * @generated from enum value: BECOME_ADMIN = 1;
   */
  BECOME_ADMIN = 1,

  /**
   * @generated from enum value: BECOME_MEMBER = 2;
   */
  BECOME_MEMBER = 2,

  /**
   * @generated from enum value: CAN_VIEW_CHANNEL = 3;
   */
  CAN_VIEW_CHANNEL = 3,

  /**
   * @generated from enum value: CAN_VIEW_AND_POST_CHANNEL = 4;
   */
  CAN_VIEW_AND_POST_CHANNEL = 4,

  /**
   * @generated from enum value: BECOME_TOKEN_MASTER = 5;
   */
  BECOME_TOKEN_MASTER = 5,

  /**
   * @generated from enum value: BECOME_TOKEN_OWNER = 6;
   */
  BECOME_TOKEN_OWNER = 6,
}

/**
 * Describes the enum CommunityTokenPermission.Type.
 */
export const CommunityTokenPermission_TypeSchema: GenEnum<CommunityTokenPermission_Type> =
  /*@__PURE__*/
  enumDesc(file_communities, 5, 0)

/**
 * @generated from message CommunityDescription
 */
export type CommunityDescription = Message<'CommunityDescription'> & {
  /**
   * @generated from field: uint64 clock = 1;
   */
  clock: bigint

  /**
   * @generated from field: map<string, CommunityMember> members = 2;
   */
  members: { [key: string]: CommunityMember }

  /**
   * @generated from field: CommunityPermissions permissions = 3;
   */
  permissions?: CommunityPermissions

  /**
   * @generated from field: ChatIdentity identity = 5;
   */
  identity?: ChatIdentity

  /**
   * @generated from field: map<string, CommunityChat> chats = 6;
   */
  chats: { [key: string]: CommunityChat }

  /**
   * @generated from field: repeated string ban_list = 7 [deprecated = true];
   * @deprecated
   */
  banList: string[]

  /**
   * @generated from field: map<string, CommunityCategory> categories = 8;
   */
  categories: { [key: string]: CommunityCategory }

  /**
   * @generated from field: uint64 archive_magnetlink_clock = 9;
   */
  archiveMagnetlinkClock: bigint

  /**
   * @generated from field: CommunityAdminSettings admin_settings = 10;
   */
  adminSettings?: CommunityAdminSettings

  /**
   * @generated from field: string intro_message = 11;
   */
  introMessage: string

  /**
   * @generated from field: string outro_message = 12;
   */
  outroMessage: string

  /**
   * @generated from field: bool encrypted = 13 [deprecated = true];
   * @deprecated
   */
  encrypted: boolean

  /**
   * @generated from field: repeated string tags = 14;
   */
  tags: string[]

  /**
   * @generated from field: map<string, CommunityTokenPermission> token_permissions = 15;
   */
  tokenPermissions: { [key: string]: CommunityTokenPermission }

  /**
   * @generated from field: repeated CommunityTokenMetadata community_tokens_metadata = 16;
   */
  communityTokensMetadata: CommunityTokenMetadata[]

  /**
   * @generated from field: uint64 active_members_count = 17;
   */
  activeMembersCount: bigint

  /**
   * @generated from field: string ID = 18;
   */
  ID: string

  /**
   * @generated from field: map<string, CommunityBanInfo> banned_members = 19;
   */
  bannedMembers: { [key: string]: CommunityBanInfo }

  /**
   * key is hash ratchet key_id + seq_no
   *
   * @generated from field: map<string, bytes> privateData = 100;
   */
  privateData: { [key: string]: Uint8Array }
}

/**
 * Describes the message CommunityDescription.
 * Use `create(CommunityDescriptionSchema)` to create a new message.
 */
export const CommunityDescriptionSchema: GenMessage<CommunityDescription> =
  /*@__PURE__*/
  messageDesc(file_communities, 6)

/**
 * @generated from message CommunityBanInfo
 */
export type CommunityBanInfo = Message<'CommunityBanInfo'> & {
  /**
   * @generated from field: bool delete_all_messages = 1;
   */
  deleteAllMessages: boolean
}

/**
 * Describes the message CommunityBanInfo.
 * Use `create(CommunityBanInfoSchema)` to create a new message.
 */
export const CommunityBanInfoSchema: GenMessage<CommunityBanInfo> =
  /*@__PURE__*/
  messageDesc(file_communities, 7)

/**
 * @generated from message CommunityAdminSettings
 */
export type CommunityAdminSettings = Message<'CommunityAdminSettings'> & {
  /**
   * @generated from field: bool pin_message_all_members_enabled = 1;
   */
  pinMessageAllMembersEnabled: boolean
}

/**
 * Describes the message CommunityAdminSettings.
 * Use `create(CommunityAdminSettingsSchema)` to create a new message.
 */
export const CommunityAdminSettingsSchema: GenMessage<CommunityAdminSettings> =
  /*@__PURE__*/
  messageDesc(file_communities, 8)

/**
 * @generated from message CommunityChat
 */
export type CommunityChat = Message<'CommunityChat'> & {
  /**
   * @generated from field: map<string, CommunityMember> members = 1;
   */
  members: { [key: string]: CommunityMember }

  /**
   * @generated from field: CommunityPermissions permissions = 2;
   */
  permissions?: CommunityPermissions

  /**
   * @generated from field: ChatIdentity identity = 3;
   */
  identity?: ChatIdentity

  /**
   * @generated from field: string category_id = 4;
   */
  categoryId: string

  /**
   * @generated from field: int32 position = 5;
   */
  position: number

  /**
   * @generated from field: bool viewers_can_post_reactions = 6;
   */
  viewersCanPostReactions: boolean
}

/**
 * Describes the message CommunityChat.
 * Use `create(CommunityChatSchema)` to create a new message.
 */
export const CommunityChatSchema: GenMessage<CommunityChat> =
  /*@__PURE__*/
  messageDesc(file_communities, 9)

/**
 * @generated from message CommunityCategory
 */
export type CommunityCategory = Message<'CommunityCategory'> & {
  /**
   * @generated from field: string category_id = 1;
   */
  categoryId: string

  /**
   * @generated from field: string name = 2;
   */
  name: string

  /**
   * @generated from field: int32 position = 3;
   */
  position: number
}

/**
 * Describes the message CommunityCategory.
 * Use `create(CommunityCategorySchema)` to create a new message.
 */
export const CommunityCategorySchema: GenMessage<CommunityCategory> =
  /*@__PURE__*/
  messageDesc(file_communities, 10)

/**
 * @generated from message RevealedAccount
 */
export type RevealedAccount = Message<'RevealedAccount'> & {
  /**
   * @generated from field: string address = 1;
   */
  address: string

  /**
   * @generated from field: bytes signature = 2;
   */
  signature: Uint8Array

  /**
   * @generated from field: repeated uint64 chain_ids = 3;
   */
  chainIds: bigint[]

  /**
   * @generated from field: bool isAirdropAddress = 4;
   */
  isAirdropAddress: boolean
}

/**
 * Describes the message RevealedAccount.
 * Use `create(RevealedAccountSchema)` to create a new message.
 */
export const RevealedAccountSchema: GenMessage<RevealedAccount> =
  /*@__PURE__*/
  messageDesc(file_communities, 11)

/**
 * @generated from message CommunityRequestToJoin
 */
export type CommunityRequestToJoin = Message<'CommunityRequestToJoin'> & {
  /**
   * @generated from field: uint64 clock = 1;
   */
  clock: bigint

  /**
   * @generated from field: string ens_name = 2;
   */
  ensName: string

  /**
   * @generated from field: string chat_id = 3;
   */
  chatId: string

  /**
   * @generated from field: bytes community_id = 4;
   */
  communityId: Uint8Array

  /**
   * @generated from field: string display_name = 5;
   */
  displayName: string

  /**
   * @generated from field: repeated RevealedAccount revealed_accounts = 6;
   */
  revealedAccounts: RevealedAccount[]
}

/**
 * Describes the message CommunityRequestToJoin.
 * Use `create(CommunityRequestToJoinSchema)` to create a new message.
 */
export const CommunityRequestToJoinSchema: GenMessage<CommunityRequestToJoin> =
  /*@__PURE__*/
  messageDesc(file_communities, 12)

/**
 * @generated from message CommunityEditSharedAddresses
 */
export type CommunityEditSharedAddresses =
  Message<'CommunityEditSharedAddresses'> & {
    /**
     * @generated from field: uint64 clock = 1;
     */
    clock: bigint

    /**
     * @generated from field: bytes community_id = 2;
     */
    communityId: Uint8Array

    /**
     * @generated from field: repeated RevealedAccount revealed_accounts = 3;
     */
    revealedAccounts: RevealedAccount[]
  }

/**
 * Describes the message CommunityEditSharedAddresses.
 * Use `create(CommunityEditSharedAddressesSchema)` to create a new message.
 */
export const CommunityEditSharedAddressesSchema: GenMessage<CommunityEditSharedAddresses> =
  /*@__PURE__*/
  messageDesc(file_communities, 13)

/**
 * @generated from message CommunityCancelRequestToJoin
 */
export type CommunityCancelRequestToJoin =
  Message<'CommunityCancelRequestToJoin'> & {
    /**
     * @generated from field: uint64 clock = 1;
     */
    clock: bigint

    /**
     * @generated from field: string ens_name = 2;
     */
    ensName: string

    /**
     * @generated from field: string chat_id = 3;
     */
    chatId: string

    /**
     * @generated from field: bytes community_id = 4;
     */
    communityId: Uint8Array

    /**
     * @generated from field: string display_name = 5;
     */
    displayName: string
  }

/**
 * Describes the message CommunityCancelRequestToJoin.
 * Use `create(CommunityCancelRequestToJoinSchema)` to create a new message.
 */
export const CommunityCancelRequestToJoinSchema: GenMessage<CommunityCancelRequestToJoin> =
  /*@__PURE__*/
  messageDesc(file_communities, 14)

/**
 * @generated from message CommunityUserKicked
 */
export type CommunityUserKicked = Message<'CommunityUserKicked'> & {
  /**
   * @generated from field: uint64 clock = 1;
   */
  clock: bigint

  /**
   * @generated from field: bytes community_id = 2;
   */
  communityId: Uint8Array
}

/**
 * Describes the message CommunityUserKicked.
 * Use `create(CommunityUserKickedSchema)` to create a new message.
 */
export const CommunityUserKickedSchema: GenMessage<CommunityUserKicked> =
  /*@__PURE__*/
  messageDesc(file_communities, 15)

/**
 * @generated from message CommunityRequestToJoinResponse
 */
export type CommunityRequestToJoinResponse =
  Message<'CommunityRequestToJoinResponse'> & {
    /**
     * @generated from field: uint64 clock = 1;
     */
    clock: bigint

    /**
     * @generated from field: CommunityDescription community = 2;
     */
    community?: CommunityDescription

    /**
     * @generated from field: bool accepted = 3;
     */
    accepted: boolean

    /**
     * @generated from field: bytes grant = 4;
     */
    grant: Uint8Array

    /**
     * @generated from field: bytes community_id = 5;
     */
    communityId: Uint8Array

    /**
     * @generated from field: string magnet_uri = 6;
     */
    magnetUri: string

    /**
     * @generated from field: bytes protected_topic_private_key = 7;
     */
    protectedTopicPrivateKey: Uint8Array

    /**
     * @generated from field: Shard shard = 8;
     */
    shard?: Shard
  }

/**
 * Describes the message CommunityRequestToJoinResponse.
 * Use `create(CommunityRequestToJoinResponseSchema)` to create a new message.
 */
export const CommunityRequestToJoinResponseSchema: GenMessage<CommunityRequestToJoinResponse> =
  /*@__PURE__*/
  messageDesc(file_communities, 16)

/**
 * @generated from message CommunityRequestToLeave
 */
export type CommunityRequestToLeave = Message<'CommunityRequestToLeave'> & {
  /**
   * @generated from field: uint64 clock = 1;
   */
  clock: bigint

  /**
   * @generated from field: bytes community_id = 2;
   */
  communityId: Uint8Array
}

/**
 * Describes the message CommunityRequestToLeave.
 * Use `create(CommunityRequestToLeaveSchema)` to create a new message.
 */
export const CommunityRequestToLeaveSchema: GenMessage<CommunityRequestToLeave> =
  /*@__PURE__*/
  messageDesc(file_communities, 17)

/**
 * @generated from message CommunityMessageArchiveMagnetlink
 */
export type CommunityMessageArchiveMagnetlink =
  Message<'CommunityMessageArchiveMagnetlink'> & {
    /**
     * @generated from field: uint64 clock = 1;
     */
    clock: bigint

    /**
     * @generated from field: string magnet_uri = 2;
     */
    magnetUri: string
  }

/**
 * Describes the message CommunityMessageArchiveMagnetlink.
 * Use `create(CommunityMessageArchiveMagnetlinkSchema)` to create a new message.
 */
export const CommunityMessageArchiveMagnetlinkSchema: GenMessage<CommunityMessageArchiveMagnetlink> =
  /*@__PURE__*/
  messageDesc(file_communities, 18)

/**
 * @generated from message WakuMessage
 */
export type WakuMessage = Message<'WakuMessage'> & {
  /**
   * @generated from field: bytes sig = 1;
   */
  sig: Uint8Array

  /**
   * @generated from field: uint64 timestamp = 2;
   */
  timestamp: bigint

  /**
   * @generated from field: bytes topic = 3;
   */
  topic: Uint8Array

  /**
   * @generated from field: bytes payload = 4;
   */
  payload: Uint8Array

  /**
   * @generated from field: bytes padding = 5;
   */
  padding: Uint8Array

  /**
   * @generated from field: bytes hash = 6;
   */
  hash: Uint8Array

  /**
   * @generated from field: string thirdPartyId = 7;
   */
  thirdPartyId: string
}

/**
 * Describes the message WakuMessage.
 * Use `create(WakuMessageSchema)` to create a new message.
 */
export const WakuMessageSchema: GenMessage<WakuMessage> =
  /*@__PURE__*/
  messageDesc(file_communities, 19)

/**
 * @generated from message WakuMessageArchiveMetadata
 */
export type WakuMessageArchiveMetadata =
  Message<'WakuMessageArchiveMetadata'> & {
    /**
     * @generated from field: uint32 version = 1;
     */
    version: number

    /**
     * @generated from field: uint64 from = 2;
     */
    from: bigint

    /**
     * @generated from field: uint64 to = 3;
     */
    to: bigint

    /**
     * @generated from field: repeated bytes contentTopic = 4;
     */
    contentTopic: Uint8Array[]
  }

/**
 * Describes the message WakuMessageArchiveMetadata.
 * Use `create(WakuMessageArchiveMetadataSchema)` to create a new message.
 */
export const WakuMessageArchiveMetadataSchema: GenMessage<WakuMessageArchiveMetadata> =
  /*@__PURE__*/
  messageDesc(file_communities, 20)

/**
 * @generated from message WakuMessageArchive
 */
export type WakuMessageArchive = Message<'WakuMessageArchive'> & {
  /**
   * @generated from field: uint32 version = 1;
   */
  version: number

  /**
   * @generated from field: WakuMessageArchiveMetadata metadata = 2;
   */
  metadata?: WakuMessageArchiveMetadata

  /**
   * @generated from field: repeated WakuMessage messages = 3;
   */
  messages: WakuMessage[]
}

/**
 * Describes the message WakuMessageArchive.
 * Use `create(WakuMessageArchiveSchema)` to create a new message.
 */
export const WakuMessageArchiveSchema: GenMessage<WakuMessageArchive> =
  /*@__PURE__*/
  messageDesc(file_communities, 21)

/**
 * @generated from message WakuMessageArchiveIndexMetadata
 */
export type WakuMessageArchiveIndexMetadata =
  Message<'WakuMessageArchiveIndexMetadata'> & {
    /**
     * @generated from field: uint32 version = 1;
     */
    version: number

    /**
     * @generated from field: WakuMessageArchiveMetadata metadata = 2;
     */
    metadata?: WakuMessageArchiveMetadata

    /**
     * @generated from field: uint64 offset = 3;
     */
    offset: bigint

    /**
     * @generated from field: uint64 size = 4;
     */
    size: bigint

    /**
     * @generated from field: uint64 padding = 5;
     */
    padding: bigint
  }

/**
 * Describes the message WakuMessageArchiveIndexMetadata.
 * Use `create(WakuMessageArchiveIndexMetadataSchema)` to create a new message.
 */
export const WakuMessageArchiveIndexMetadataSchema: GenMessage<WakuMessageArchiveIndexMetadata> =
  /*@__PURE__*/
  messageDesc(file_communities, 22)

/**
 * @generated from message WakuMessageArchiveIndex
 */
export type WakuMessageArchiveIndex = Message<'WakuMessageArchiveIndex'> & {
  /**
   * @generated from field: map<string, WakuMessageArchiveIndexMetadata> archives = 1;
   */
  archives: { [key: string]: WakuMessageArchiveIndexMetadata }
}

/**
 * Describes the message WakuMessageArchiveIndex.
 * Use `create(WakuMessageArchiveIndexSchema)` to create a new message.
 */
export const WakuMessageArchiveIndexSchema: GenMessage<WakuMessageArchiveIndex> =
  /*@__PURE__*/
  messageDesc(file_communities, 23)

/**
 * @generated from message CommunityPublicStorenodesInfo
 */
export type CommunityPublicStorenodesInfo =
  Message<'CommunityPublicStorenodesInfo'> & {
    /**
     * Signature of the payload field
     *
     * @generated from field: bytes signature = 1;
     */
    signature: Uint8Array

    /**
     * Marshaled CommunityStorenodes
     *
     * @generated from field: bytes payload = 2;
     */
    payload: Uint8Array
  }

/**
 * Describes the message CommunityPublicStorenodesInfo.
 * Use `create(CommunityPublicStorenodesInfoSchema)` to create a new message.
 */
export const CommunityPublicStorenodesInfoSchema: GenMessage<CommunityPublicStorenodesInfo> =
  /*@__PURE__*/
  messageDesc(file_communities, 24)

/**
 * @generated from message CommunityStorenodes
 */
export type CommunityStorenodes = Message<'CommunityStorenodes'> & {
  /**
   * @generated from field: uint64 clock = 1;
   */
  clock: bigint

  /**
   * @generated from field: bytes community_id = 2;
   */
  communityId: Uint8Array

  /**
   * @generated from field: repeated Storenode storenodes = 3;
   */
  storenodes: Storenode[]

  /**
   * @generated from field: uint64 chain_id = 4;
   */
  chainId: bigint
}

/**
 * Describes the message CommunityStorenodes.
 * Use `create(CommunityStorenodesSchema)` to create a new message.
 */
export const CommunityStorenodesSchema: GenMessage<CommunityStorenodes> =
  /*@__PURE__*/
  messageDesc(file_communities, 25)

/**
 * @generated from message Storenode
 */
export type Storenode = Message<'Storenode'> & {
  /**
   * @generated from field: bytes community_id = 1;
   */
  communityId: Uint8Array

  /**
   * @generated from field: string storenode_id = 2;
   */
  storenodeId: string

  /**
   * @generated from field: string name = 3;
   */
  name: string

  /**
   * @generated from field: string address = 4;
   */
  address: string

  /**
   * @generated from field: string fleet = 5;
   */
  fleet: string

  /**
   * @generated from field: uint32 version = 6;
   */
  version: number

  /**
   * @generated from field: bool removed = 7;
   */
  removed: boolean

  /**
   * @generated from field: int64 deleted_at = 8;
   */
  deletedAt: bigint
}

/**
 * Describes the message Storenode.
 * Use `create(StorenodeSchema)` to create a new message.
 */
export const StorenodeSchema: GenMessage<Storenode> =
  /*@__PURE__*/
  messageDesc(file_communities, 26)

/**
 * @generated from message CommunityReevaluatePermissionsRequest
 */
export type CommunityReevaluatePermissionsRequest =
  Message<'CommunityReevaluatePermissionsRequest'> & {
    /**
     * @generated from field: bytes community_id = 1;
     */
    communityId: Uint8Array
  }

/**
 * Describes the message CommunityReevaluatePermissionsRequest.
 * Use `create(CommunityReevaluatePermissionsRequestSchema)` to create a new message.
 */
export const CommunityReevaluatePermissionsRequestSchema: GenMessage<CommunityReevaluatePermissionsRequest> =
  /*@__PURE__*/
  messageDesc(file_communities, 27)
